import React, { useState } from "react";
import { Modal, TextInput, Button, Text, Stack } from "@mantine/core";
import { requestPasswordReset } from "../../api";
import { notifications } from "@mantine/notifications";

export const ForgotPasswordModal = ({ opened, onClose }) => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      await requestPasswordReset(email);
      notifications.show({
        message:
          "If an account exists with this email, you will receive reset instructions.",
        color: "green",
        autoClose: 5000,
      });
      onClose();
    } catch (error) {
      notifications.show({
        message:
          error.response?.data?.detail ||
          "An error occurred. Please try again.",
        color: "red",
        autoClose: 5000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal opened={opened} onClose={onClose} title="Reset Password" centered>
      <form onSubmit={handleSubmit}>
        <Stack>
          <Text size="sm">
            Enter your email address and we'll send you instructions to reset
            your password.
          </Text>
          <TextInput
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <Button type="submit" loading={isLoading} fullWidth>
            Send Reset Instructions
          </Button>
        </Stack>
      </form>
    </Modal>
  );
};
